export const Canada = {
    name: "Canada",
    image: "/Canada.jpg",
    overview: {
        title: "Why Bangladeshi Students Choose Canada for Higher Studies?",
        descriptions: [
            "Bangladeshi students choose Canada for its high-quality education, affordable tuition, and post-study work opportunities. The country's diverse, inclusive culture and safe environment make it welcoming for international students.",
            "Additionally, Canada offers pathways to permanent residency, making it an attractive option for a successful future."
        ],
    },
    highlights: [
        {
            icon: "fas fa-city",
            title: "Student-friendly cities",
            description: "Three Canadian cities rank in the top 50 of the QS Best Student Cities 2024."
        },
        {
            icon: "fas fa-briefcase",
            title: "Post-study work rights",
            description: "Canada offers up to 3 years of post-study work opportunities."
        },
        {
            icon: "fas fa-graduation-cap",
            title: "Top universities",
            description: "Canada has 3 universities in the top 50 of the QS World University Rankings 2024, with 31 universities ranked overall."
        },
        {
            icon: "fas fa-users",
            title: "Multicultural experience",
            description: "Canada's diverse student population provides a rich, multicultural educational experience."
        }
    ],
    keyFacts: [
        { factNumber: "156+", factLabel: "Universities and colleges" },
        { factNumber: "6,42,000", factLabel: "International Students in Canada in 2024" },
        { factNumber: "24 Hours", factLabel: "Per week Part-time work permit" },
        { factNumber: "3 Years", factLabel: "Post-study work permit" }
    ],
    stats: {
        capital: "Ottawa",
        poplulation: "41.4 million",
        economicGrowthRate: "2.2%",
        currency: "Canadian Dollar (CAD)",
        language: "English",
        weather: [
            "Montreal: 15°C - 25°C",
            "Vancouver: 13°C - 22°C",
            "Calgary: 8°C - 24°C",
            "Toronto: 16°C - 26°C"
        ]
    },
    requirements: [
        "Academic transcripts",
        "Standardized test scores (SAT, GMAT, GRE, LSAT)",
        "English proficiency test scores (TOEFL, IELTS, PTE, Duolingo, CAEL)",
        "Statement of Purpose and Essay",
        "Provincial Attestation Letter (PAL)",
        "Letter of Recommendation",
        "Valid passport copy",
        "Proof of finances (Guaranteed Investment Certificate)"
    ],
    intake: {
        title: "Canadian colleges and universities offer three intakes, also known as semesters:",
        intakes: [
            {
                name: "Winter Intake",
                month: "Starts in January/February"
            },
            {
                name: "Fall Intake",
                month: "Starts in August/September"
            },
            {
                name: "Summer Intake",
                month: "Starts in April/May"
            }
        ]
    },
    programs: [
        {
            name: "Certificates and Diploma",
            duration: "1-2 years"
        },
        {
            name: "Advanced Diploma",
            duration: "3 Years"
        },
        {
            name: "Associate Degree",
            duration: "2 years"
        },
        {
            name: "Bachelor's Degree",
            duration: "4 years"
        },
        {
            name: "Postgraduate Diploma",
            duration: "1-2 years"
        },
        {
            name: "Master's Degree",
            duration: "2 years"
        }
    ],
    popularPrograms: {
        title: "Canada offers high-quality education across a range of fields. Popular programs for international students include:",
        programs: [
            "Accounting",
            "Engineering",
            "Business Analytics",
            "Biotechnology",
            "Computer Science & IT",
            "Data Science",
            "Marketing, Media & Communication",
            "Health Science",
            "Construction Management"
        ]
    },
    costs: [
        {
            program: "Foundational Courses",
            local: "CAD 23,000 - 35,000",
            bdt: "22,08,000 – 33,60,000 BDT"
        },
        {
            program: "Undergraduate Courses",
            local: "CAD 20,000 - 35,000",
            bdt: "19,20,000 – 33,60,000 BDT"
        },
        {
            program: "Postgraduate Courses",
            local: "CAD 20,120",
            bdt: "1670,000 - 1680,000 BDT"
        },
        {
            program: "Doctorate Courses",
            local: "CAD 8,000 to CAD 20,000",
            bdt: "700,000 - 1600,000 BDT"
        },
        {
            program: "MBA Courses",
            local: "CAD 30,000 to CAD 40,000",
            bdt: "2400,000 - 3400,000 BDT"
        }
    ],
    topCities: {
        title: "Canada boasts top-ranked universities in several popular cities, offering a lifestyle akin to that in the U.S. and various employment opportunities. Key student cities include:",
        cities: [
            {
                name: "Montreal",
                description: "Bilingual cultural hub with world-class universities, vibrant arts scene, and affordable living costs"
            },
            {
                name: "Toronto",
                description: "Canada's largest city with top universities, diverse job market, and multicultural environment"
            },
            {
                name: "Vancouver",
                description: "Beautiful coastal city with mild climate, strong tech industry, and outdoor lifestyle opportunities"
            },
            {
                name: "Ottawa",
                description: "Capital city with government opportunities, bilingual environment, and excellent quality of life"
            },
            {
                name: "Quebec City",
                description: "Historic French-speaking city with rich culture, affordable education, and European charm"
            },
            {
                name: "Edmonton",
                description: "Alberta's capital with growing tech sector, lower living costs, and strong job market"
            },
            {
                name: "Winnipeg",
                description: "Affordable prairie city with friendly community, growing economy, and lower tuition costs"
            },
            {
                name: "Calgary",
                description: "Energy sector hub with high employment rates, outdoor activities, and business opportunities"
            }
        ]
    },
    workOptions: {
        partTimeWork: "With a Canadian student visa, international students can work up to 20 hours per week while studying, typically earning around $13-16 per hour. Recently, those with off-campus work authorization on their study permit are no longer limited to 20 hours per week. Students can generally work full-time during school breaks.",
        postStudyWork: "The eligibility for a Post-Graduation Work Permit (PGWP) in Canada depends on the course and its duration. The permit is typically issued for the length of the study program, up to a maximum of 3 years. This permit allows graduates to stay in Canada and gain work experience, which can be valuable for qualifying for permanent residency through the Express Entry system."
    },
    faqs: [
        {
            question: "How do I apply for a study permit in Canada?",
            answer: "To apply for a study permit, you'll need an acceptance letter from a Designated Learning Institution (DLI), proof of funds, and a clean criminal record. The application process is typically online or through a Canadian visa application center."
        },
        {
            question: "What are the language requirements for studying in Canada?",
            answer: "Most Canadian institutions require proof of English or French proficiency. Common tests include IELTS, TOEFL, and DELF/DALF."
        },
        {
            question: "Can I work while studying in Canada?",
            answer: "Yes, international students can work part-time during the academic year and full-time during breaks. The Post-Graduation Work Permit Program (PGWPP) allows graduates to work in Canada after their studies."
        },
        {
            question: "Are scholarships available for international students in Canada?",
            answer: "Yes, there are various scholarships offered by the government, universities, and external organizations."
        },
        {
            question: "How much does it cost to study in Canada from Bangladesh?",
            answer: "Studying in Canada from Bangladesh costs around USD 7,000 to USD 29,000 for tuition, USD 3,000 to USD 7,000 for accommodation, and USD 10,000 to USD 15,000 for living expenses. Health insurance costs USD 600 to USD 900. Scholarships and part-time work can help reduce costs."
        },
        {
            question: "How much GPA is required to study in Canada from Bangladesh?",
            answer: "To study in Canada from Bangladesh, the required GPA typically ranges from <strong>2.5 to 3.5</strong> on a 4.0 scale, depending on the university and program. Competitive programs may require higher GPAs, especially for postgraduate studies. It's important to check specific university requirements for more accurate information."
        }
    ]
}